import type { PageKind } from '@graphql/generated-base';
import { findCustomPageBySlug, selectRoutedPageKind, toPageContainerSlug } from '@shared/utils/migratedCustomPages';
import type { GuestPageContainerBySlugQueryVariables } from '../Custom.graphql.generated';

export type CustomDataPage = Readonly<{ pageSlug: string; pageKind?: PageKind | null }>;

/**
 * The container slug and `pageKind` a Custom widget fetches for `pageSlug`. See useCustomData for
 * why only a contested slug on its own `/page/<slug>` URL sends a `pageKind`.
 */
export const resolveCustomDataRequest = (pageSlug: string, pages: ReadonlyArray<CustomDataPage> | undefined, isRoutedAtThisPage: boolean) => {
  const routedPageKind = selectRoutedPageKind(pages, pageSlug, isRoutedAtThisPage);
  const containerSlug = toPageContainerSlug(pageSlug, routedPageKind ?? findCustomPageBySlug(pages, pageSlug)?.pageKind);
  return { containerSlug, routedPageKind };
};

/**
 * GuestPageContainerBySlug variables. The one builder for both useCustomData and
 * BulkCustomPageDataProvider, whose cache writes must land on the widget's exact cache key.
 */
export const toCustomDataVariables = (
  eventHandle: string,
  containerSlug: string,
  isAdminDashboard: boolean,
  pageKind: PageKind | undefined,
): GuestPageContainerBySlugQueryVariables => ({
  payload: {
    eventName: eventHandle,
    pageSlug: containerSlug,
  },
  isAdminDashboard,
  // Undefined is dropped from the request, so the canonical route's cache key is unchanged.
  pageKind,
});
